import {useFormikContext} from 'formik';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {TState} from '../../../../../../redux/store.type';
import {getDateFormat} from '../../../../../../library/dates';
import {DEFAULT_TIME_ZONE} from '../../../../../../globalVariables/locals';
import {calculatePriceRange} from '../../../../utils/planCalculations';
import * as css from './ReviewStep.css';
import {SubscriptionFormValues} from '../../createSubscriptionForm.types';
import Timeline from '../../../timeline/Timeline';
import {timelinePoints} from '../components/ValidityAndTimesSection';
import getSpecialTranslation from '../../../../../../functions/getSpecialTranslation';
import {PriceGroup} from '../../../../../../redux/subscription/subscription.type';
import {useEffect} from 'react';
import {getPriceGroupsByPackage} from '../../../../../../redux/subscription/subscriptionActions';

function ReviewStep() {
    const {t} = useTranslation('subscriptions');
    const {t: tLayout} = useTranslation('layout');
    const {values} = useFormikContext<SubscriptionFormValues>();
    const planTid = useSelector((state: TState) => state.subscription.currentPlan);
    const priceGroups = useSelector((state: TState) => state.subscription.priceGroups || []);
    const timeZone = useSelector((state: TState) => state.event?.timeZone) || DEFAULT_TIME_ZONE;
    const categoriesData = useSelector((state: any) => state.categories.eventCategories);
    const getPriceGroupsByPackageXHR = useSelector((state: TState) => state.subscription.getPriceGroupsByPackageXHR);
    const priceGroupIds = values.priceGroupIds || [];
    const selectedPriceGroups = (priceGroups || []).filter((pg: PriceGroup) => priceGroupIds.includes(pg.spgId));
    
    const currentPlan = {
        planTid: planTid || null,
        title: values.subscriptionName,
        planType: values.subscriptionType,
        active: values.active,
        categories: values.category || [],
        image: values.image,
        description: values.description,
        prices: values.prices || []
    };
    
    const selectedCategories = currentPlan.categories?.map((cat: number) => 
        getSpecialTranslation(`category${cat}`, tLayout) || categoriesData?.find((c: any) => c.catId === cat)?.title || ''
    ) || [];

    const subscriptionTypeLabels: Record<string, string> = {
        'open': t('openSubscription'),
        'closed': t('closedSubscription'),
        'mixed': t('mixedSubscription')
    };

    const formatSaleDate = (date: string | number, time: string | number): string => {
        if(!date || !time) return '-';
        return `${getDateFormat(date, 'DD.MM.YY', timeZone)} | ${getDateFormat(time, 'HH:mm', timeZone)}`;
    };

    if(!currentPlan) {
        return null;
    }
    useEffect(() => {
        if(!getPriceGroupsByPackageXHR) {
            getPriceGroupsByPackage();
        }
    }, []);
    return (
        <>
            <css.section>
                <css.sectionTitle>{t('subscriptionDetails')}</css.sectionTitle>
                <css.sectionContent>
                    <css.detailItem>
                        <css.label>{t('planName')}:</css.label>
                        <css.value>{currentPlan.title || '-'}</css.value>
                    </css.detailItem>
                    <css.detailItem>
                        <css.label>{t('planTypeTitle')}:</css.label>
                        <css.value>{subscriptionTypeLabels[currentPlan.planType] || '-'}</css.value>
                    </css.detailItem>
                    <css.detailItem>
                        <css.label>{t('category')}:</css.label>
                        <css.value>
                            {selectedCategories.length > 0 
                                ? selectedCategories.join(', ')
                                : '-'
                            }
                        </css.value>
                    </css.detailItem>
                    <css.detailItem>
                        <css.label>{t('redemption')}:</css.label>
                        <css.value>
                            {selectedPriceGroups.length > 0 ? selectedPriceGroups.map((pg: PriceGroup) => pg.title).join(', ') : '-'}
                        </css.value>
                    </css.detailItem>
                    <css.detailItem>
                        <css.label>{t('priceRange')}:</css.label>
                        <css.value>{calculatePriceRange(currentPlan as any)}</css.value>
                    </css.detailItem>
                    <css.detailItem>
                        <css.label>{t('saleStartDate')}:</css.label>
                        <css.value>{formatSaleDate(values.saleStartDate, values.saleStartTime)}</css.value>
                    </css.detailItem>
                    <css.detailItem>
                        <css.label>{t('saleEndDate')}:</css.label>
                        <css.value>{formatSaleDate(values.saleEndDate, values.saleEndTime)}</css.value>
                    </css.detailItem>
                </css.sectionContent>
            </css.section>
            <css.sectionTitle>{t('validityAndTimes')}</css.sectionTitle>
            <css.value>{t('subscriptionLifecycleBar')}</css.value>
            <Timeline points={timelinePoints} />
        </>
    );
}

export default ReviewStep;

